import React, { Fragment } from 'react';
import { Spinner, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import is from 'is_js';
import { getDetails } from './customers/details.ts';

const Loading = ({ msg = 'Retrieving personalized data ...' }) => {
  // const mobile = window.innerWidth < 768;
  const mobile = is.mobile();
  const { backgroundColor, logo, companyName } = getDetails();
  return (
    <Fragment>
      <Row className="pb-3">
        <Col className="text-center">
          <img
            width={mobile ? '100' : '150'}
            height={mobile ? '100' : '150'}
            src="/logos/hdlogo.svg"
            data-src="/logos/hdlogo.svg"
            className=""
            alt="Home Depot Logo"
          />
        </Col>
        <Col className="text-center">
          <img
            style={{
              backgroundColor,
              objectFit: 'contain'
            }}
            width={mobile ? '100' : '150'}
            height={mobile ? '100' : '150'}
            src={logo}
            data-src={logo}
            className="p-1"
            alt={`${companyName} Logo`}
          />
        </Col>
      </Row>
      <Row>
        <Flex justifyContent="center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Flex>
      </Row>
      <Flex justifyContent="center">
        <Row className="mt-2">{msg}</Row>
      </Flex>
    </Fragment>
  );
};

Loading.propTypes = {
  msg: PropTypes.string
};

export default Loading;
